import { LeadCaptureProps } from '../components/LeadCapture'
import Grid from '../components/grid'
import IndexText from '../components/index-text'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import CMSFormComponent from '../v2/components/CMSForm'
import { Form } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { IoMdReturnRight } from 'react-icons/io'
import { IoCheckmark } from 'react-icons/io5'
import { RichText } from '../v2/components/RichText'

function VerticalLine({ className }: { className?: string }) {
  return (
    <div
      className={`bg-telesoft hidden h-full opacity-60 backdrop-blur-sm lg:row-span-1 lg:block ${className}`}
    ></div>
  )
}

type BlockProps = Extract<LeadCaptureProps, { blockType: 'lead-capture' }>

export default function LeadCaptureForm(block: BlockProps): ReactElement {
  const { title, subTitle = 'Threat Hunting', description, items, form } = block

  return (
    <Container className="h-full w-full">
      <Grid id="demonstration-form" className="z-10 flex h-full w-full flex-col">
        <VerticalLine />
        <VerticalLine />
        <VerticalLine />
        <div className="col-span-full h-full flex-col items-start justify-center border bg-white bg-opacity-90 p-8 backdrop-blur-md  lg:col-span-6 lg:flex lg:p-12">
          <IndexText index={subTitle} type="text" className="ml-6" />
          <div className="flex items-center justify-start">
            <IoMdReturnRight className="mr-2 text-black" />
            <Text variant="mediumHeading" className="">
              {title}
            </Text>
          </div>
          <div className="mt-8">
            <RichText content={description} />
          </div>
          <div className="my-8 grid max-w-xl grid-cols-2 gap-4">
            {items &&
              items?.length > 0 &&
              items.map((item: any) => {
                return <ListItem key={`list--item--map--${item.text}`}>{item.text}</ListItem>
              })}
          </div>
          <CMSFormComponent form={form as Form} />
        </div>
        <VerticalLine />
        <VerticalLine />
        <VerticalLine />
      </Grid>
    </Container>
  )
}

export function ListItem({ children }: { children: React.ReactNode }) {
  return (
    <div className="col-span-full flex items-center justify-start md:col-span-1">
      <div className="mr-3 h-auto w-4 border-b border-t border-black">
        <IoCheckmark className="text-telesoft" />
      </div>
      <Text className="font-medium text-black">{children}</Text>
    </div>
  )
}
